import React from "react";
import { makeStyles, Button } from "@material-ui/core";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const ExportExcel = ({ exportFunction, fileName }) => {
  const classes = useStyles();
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = async (fileName) => {
    let jsonData = await exportFunction();

    if (jsonData.length > 0) {
      const ws = XLSX.utils.json_to_sheet(jsonData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    }
  };

  return (
    <Button
      color="primary"
      variant="contained"
      className={classes.button}
      onClick={(e) => exportToExcel(fileName)}
    >
      Exportar
    </Button>
  );
};

const useStyles = makeStyles((theme) => ({
  button: {
    marginRight: theme.spacing(0.8),
    padding: ".5em 3em",
    borderRadius: "10px",
  },
}));

export default ExportExcel;
